module.exports = __webpack_public_path__ + "media/kuala lumpur/menu-96d40f36.jpg";